package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * British Indian Ocean Territory Flag (32x24dp)
 *
 * - ISO Alpha-2: IO
 * - ISO Alpha-3: IOT
 * - ISO Numeric: 086
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.BritishIndianOceanTerritory: ImageVector by lazy {
    ImageVector.Builder(
        name = "British Indian Ocean Territory:IO:IOT:086:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(-1.506f, 3.291f)
                lineTo(-0.019f, 4.709f)
                curveTo(1.209f, 3.548f, 2.368f, 3f, 3.469f, 3f)
                curveTo(4.001f, 3f, 4.228f, 3.128f, 4.841f, 3.709f)
                curveTo(5.815f, 4.628f, 6.47f, 5f, 7.701f, 5f)
                curveTo(8.932f, 5f, 9.587f, 4.628f, 10.56f, 3.709f)
                curveTo(11.174f, 3.128f, 11.4f, 3f, 11.932f, 3f)
                curveTo(12.464f, 3f, 12.691f, 3.128f, 13.304f, 3.709f)
                curveTo(14.278f, 4.628f, 14.933f, 5f, 16.164f, 5f)
                curveTo(17.395f, 5f, 18.05f, 4.628f, 19.023f, 3.709f)
                curveTo(19.637f, 3.128f, 19.863f, 3f, 20.395f, 3f)
                curveTo(20.927f, 3f, 21.154f, 3.128f, 21.767f, 3.709f)
                curveTo(22.741f, 4.628f, 23.396f, 5f, 24.627f, 5f)
                curveTo(25.858f, 5f, 26.513f, 4.628f, 27.486f, 3.709f)
                curveTo(28.1f, 3.128f, 28.326f, 3f, 28.858f, 3f)
                curveTo(29.959f, 3f, 31.118f, 3.548f, 32.346f, 4.709f)
                lineTo(33.833f, 3.291f)
                curveTo(32.24f, 1.786f, 30.578f, 1f, 28.858f, 1f)
                curveTo(27.627f, 1f, 26.972f, 1.372f, 25.999f, 2.291f)
                curveTo(25.385f, 2.872f, 25.159f, 3f, 24.627f, 3f)
                curveTo(24.095f, 3f, 23.868f, 2.872f, 23.255f, 2.291f)
                curveTo(22.281f, 1.372f, 21.626f, 1f, 20.395f, 1f)
                curveTo(19.164f, 1f, 18.509f, 1.372f, 17.536f, 2.291f)
                curveTo(16.922f, 2.872f, 16.696f, 3f, 16.164f, 3f)
                curveTo(15.632f, 3f, 15.405f, 2.872f, 14.792f, 2.291f)
                curveTo(13.818f, 1.372f, 13.163f, 1f, 11.932f, 1f)
                curveTo(10.701f, 1f, 10.046f, 1.372f, 9.073f, 2.291f)
                curveTo(8.459f, 2.872f, 8.233f, 3f, 7.701f, 3f)
                curveTo(7.169f, 3f, 6.942f, 2.872f, 6.329f, 2.291f)
                curveTo(5.355f, 1.372f, 4.7f, 1f, 3.469f, 1f)
                curveTo(1.75f, 1f, 0.087f, 1.786f, -1.506f, 3.291f)
                close()
                moveTo(-0.019f, 8.709f)
                lineTo(-1.506f, 7.291f)
                curveTo(0.087f, 5.786f, 1.75f, 5f, 3.469f, 5f)
                curveTo(4.7f, 5f, 5.355f, 5.372f, 6.329f, 6.291f)
                curveTo(6.942f, 6.872f, 7.169f, 7f, 7.701f, 7f)
                curveTo(8.233f, 7f, 8.459f, 6.872f, 9.073f, 6.291f)
                curveTo(10.046f, 5.372f, 10.701f, 5f, 11.932f, 5f)
                curveTo(13.163f, 5f, 13.818f, 5.372f, 14.792f, 6.291f)
                curveTo(15.405f, 6.872f, 15.632f, 7f, 16.164f, 7f)
                curveTo(16.696f, 7f, 16.922f, 6.872f, 17.536f, 6.291f)
                curveTo(18.509f, 5.372f, 19.164f, 5f, 20.395f, 5f)
                curveTo(21.626f, 5f, 22.281f, 5.372f, 23.255f, 6.291f)
                curveTo(23.868f, 6.872f, 24.095f, 7f, 24.627f, 7f)
                curveTo(25.159f, 7f, 25.385f, 6.872f, 25.999f, 6.291f)
                curveTo(26.972f, 5.372f, 27.627f, 5f, 28.858f, 5f)
                curveTo(30.578f, 5f, 32.24f, 5.786f, 33.833f, 7.291f)
                lineTo(32.346f, 8.709f)
                curveTo(31.118f, 7.548f, 29.959f, 7f, 28.858f, 7f)
                curveTo(28.326f, 7f, 28.1f, 7.128f, 27.486f, 7.709f)
                curveTo(26.513f, 8.628f, 25.858f, 9f, 24.627f, 9f)
                curveTo(23.396f, 9f, 22.741f, 8.628f, 21.767f, 7.709f)
                curveTo(21.154f, 7.128f, 20.927f, 7f, 20.395f, 7f)
                curveTo(19.863f, 7f, 19.637f, 7.128f, 19.023f, 7.709f)
                curveTo(18.05f, 8.628f, 17.395f, 9f, 16.164f, 9f)
                curveTo(14.933f, 9f, 14.278f, 8.628f, 13.304f, 7.709f)
                curveTo(12.691f, 7.128f, 12.464f, 7f, 11.932f, 7f)
                curveTo(11.4f, 7f, 11.174f, 7.128f, 10.56f, 7.709f)
                curveTo(9.587f, 8.628f, 8.932f, 9f, 7.701f, 9f)
                curveTo(6.47f, 9f, 5.815f, 8.628f, 4.841f, 7.709f)
                curveTo(4.228f, 7.128f, 4.001f, 7f, 3.469f, 7f)
                curveTo(2.368f, 7f, 1.209f, 7.548f, -0.019f, 8.709f)
                close()
                moveTo(-0.019f, 12.708f)
                lineTo(-1.506f, 11.292f)
                curveTo(0.087f, 9.786f, 1.75f, 9f, 3.469f, 9f)
                curveTo(4.7f, 9f, 5.355f, 9.372f, 6.329f, 10.292f)
                curveTo(6.942f, 10.872f, 7.169f, 11f, 7.701f, 11f)
                curveTo(8.233f, 11f, 8.459f, 10.872f, 9.073f, 10.292f)
                curveTo(10.046f, 9.372f, 10.701f, 9f, 11.932f, 9f)
                curveTo(13.163f, 9f, 13.818f, 9.372f, 14.792f, 10.292f)
                curveTo(15.405f, 10.872f, 15.632f, 11f, 16.164f, 11f)
                curveTo(16.696f, 11f, 16.922f, 10.872f, 17.536f, 10.292f)
                curveTo(18.509f, 9.372f, 19.164f, 9f, 20.395f, 9f)
                curveTo(21.626f, 9f, 22.281f, 9.372f, 23.255f, 10.292f)
                curveTo(23.868f, 10.872f, 24.095f, 11f, 24.627f, 11f)
                curveTo(25.159f, 11f, 25.385f, 10.872f, 25.999f, 10.292f)
                curveTo(26.972f, 9.372f, 27.627f, 9f, 28.858f, 9f)
                curveTo(30.578f, 9f, 32.24f, 9.786f, 33.833f, 11.292f)
                lineTo(32.346f, 12.708f)
                curveTo(31.118f, 11.548f, 29.959f, 11f, 28.858f, 11f)
                curveTo(28.326f, 11f, 28.1f, 11.128f, 27.486f, 11.708f)
                curveTo(26.513f, 12.628f, 25.858f, 13f, 24.627f, 13f)
                curveTo(23.396f, 13f, 22.741f, 12.628f, 21.767f, 11.708f)
                curveTo(21.154f, 11.128f, 20.927f, 11f, 20.395f, 11f)
                curveTo(19.863f, 11f, 19.637f, 11.128f, 19.023f, 11.708f)
                curveTo(18.05f, 12.628f, 17.395f, 13f, 16.164f, 13f)
                curveTo(14.933f, 13f, 14.278f, 12.628f, 13.304f, 11.708f)
                curveTo(12.691f, 11.128f, 12.464f, 11f, 11.932f, 11f)
                curveTo(11.4f, 11f, 11.174f, 11.128f, 10.56f, 11.708f)
                curveTo(9.587f, 12.628f, 8.932f, 13f, 7.701f, 13f)
                curveTo(6.47f, 13f, 5.815f, 12.628f, 4.841f, 11.708f)
                curveTo(4.228f, 11.128f, 4.001f, 11f, 3.469f, 11f)
                curveTo(2.368f, 11f, 1.209f, 11.548f, -0.019f, 12.708f)
                close()
                moveTo(-0.019f, 16.708f)
                lineTo(-1.506f, 15.292f)
                curveTo(0.087f, 13.786f, 1.75f, 13f, 3.469f, 13f)
                curveTo(4.7f, 13f, 5.355f, 13.372f, 6.329f, 14.292f)
                curveTo(6.942f, 14.872f, 7.169f, 15f, 7.701f, 15f)
                curveTo(8.233f, 15f, 8.459f, 14.872f, 9.073f, 14.292f)
                curveTo(10.046f, 13.372f, 10.701f, 13f, 11.932f, 13f)
                curveTo(13.163f, 13f, 13.818f, 13.372f, 14.792f, 14.292f)
                curveTo(15.405f, 14.872f, 15.632f, 15f, 16.164f, 15f)
                curveTo(16.696f, 15f, 16.922f, 14.872f, 17.536f, 14.292f)
                curveTo(18.509f, 13.372f, 19.164f, 13f, 20.395f, 13f)
                curveTo(21.626f, 13f, 22.281f, 13.372f, 23.255f, 14.292f)
                curveTo(23.868f, 14.872f, 24.095f, 15f, 24.627f, 15f)
                curveTo(25.159f, 15f, 25.385f, 14.872f, 25.999f, 14.292f)
                curveTo(26.972f, 13.372f, 27.627f, 13f, 28.858f, 13f)
                curveTo(30.578f, 13f, 32.24f, 13.786f, 33.833f, 15.292f)
                lineTo(32.346f, 16.708f)
                curveTo(31.118f, 15.548f, 29.959f, 15f, 28.858f, 15f)
                curveTo(28.326f, 15f, 28.1f, 15.128f, 27.486f, 15.708f)
                curveTo(26.513f, 16.628f, 25.858f, 17f, 24.627f, 17f)
                curveTo(23.396f, 17f, 22.741f, 16.628f, 21.767f, 15.708f)
                curveTo(21.154f, 15.128f, 20.927f, 15f, 20.395f, 15f)
                curveTo(19.863f, 15f, 19.637f, 15.128f, 19.023f, 15.708f)
                curveTo(18.05f, 16.628f, 17.395f, 17f, 16.164f, 17f)
                curveTo(14.933f, 17f, 14.278f, 16.628f, 13.304f, 15.708f)
                curveTo(12.691f, 15.128f, 12.464f, 15f, 11.932f, 15f)
                curveTo(11.4f, 15f, 11.174f, 15.128f, 10.56f, 15.708f)
                curveTo(9.587f, 16.628f, 8.932f, 17f, 7.701f, 17f)
                curveTo(6.47f, 17f, 5.815f, 16.628f, 4.841f, 15.708f)
                curveTo(4.228f, 15.128f, 4.001f, 15f, 3.469f, 15f)
                curveTo(2.368f, 15f, 1.209f, 15.548f, -0.019f, 16.708f)
                close()
                moveTo(-0.019f, 20.708f)
                lineTo(-1.506f, 19.292f)
                curveTo(0.087f, 17.786f, 1.75f, 17f, 3.469f, 17f)
                curveTo(4.7f, 17f, 5.355f, 17.372f, 6.329f, 18.292f)
                curveTo(6.942f, 18.872f, 7.169f, 19f, 7.701f, 19f)
                curveTo(8.233f, 19f, 8.459f, 18.872f, 9.073f, 18.292f)
                curveTo(10.046f, 17.372f, 10.701f, 17f, 11.932f, 17f)
                curveTo(13.163f, 17f, 13.818f, 17.372f, 14.792f, 18.292f)
                curveTo(15.405f, 18.872f, 15.632f, 19f, 16.164f, 19f)
                curveTo(16.696f, 19f, 16.922f, 18.872f, 17.536f, 18.292f)
                curveTo(18.509f, 17.372f, 19.164f, 17f, 20.395f, 17f)
                curveTo(21.626f, 17f, 22.281f, 17.372f, 23.255f, 18.292f)
                curveTo(23.868f, 18.872f, 24.095f, 19f, 24.627f, 19f)
                curveTo(25.159f, 19f, 25.385f, 18.872f, 25.999f, 18.292f)
                curveTo(26.972f, 17.372f, 27.627f, 17f, 28.858f, 17f)
                curveTo(30.578f, 17f, 32.24f, 17.786f, 33.833f, 19.292f)
                lineTo(32.346f, 20.708f)
                curveTo(31.118f, 19.548f, 29.959f, 19f, 28.858f, 19f)
                curveTo(28.326f, 19f, 28.1f, 19.128f, 27.486f, 19.708f)
                curveTo(26.513f, 20.628f, 25.858f, 21f, 24.627f, 21f)
                curveTo(23.396f, 21f, 22.741f, 20.628f, 21.767f, 19.708f)
                curveTo(21.154f, 19.128f, 20.927f, 19f, 20.395f, 19f)
                curveTo(19.863f, 19f, 19.637f, 19.128f, 19.023f, 19.708f)
                curveTo(18.05f, 20.628f, 17.395f, 21f, 16.164f, 21f)
                curveTo(14.933f, 21f, 14.278f, 20.628f, 13.304f, 19.708f)
                curveTo(12.691f, 19.128f, 12.464f, 19f, 11.932f, 19f)
                curveTo(11.4f, 19f, 11.174f, 19.128f, 10.56f, 19.708f)
                curveTo(9.587f, 20.628f, 8.932f, 21f, 7.701f, 21f)
                curveTo(6.47f, 21f, 5.815f, 20.628f, 4.841f, 19.708f)
                curveTo(4.228f, 19.128f, 4.001f, 19f, 3.469f, 19f)
                curveTo(2.368f, 19f, 1.209f, 19.548f, -0.019f, 20.708f)
                close()
                moveTo(-0.019f, 24.708f)
                lineTo(-1.506f, 23.292f)
                curveTo(0.087f, 21.786f, 1.75f, 21f, 3.469f, 21f)
                curveTo(4.7f, 21f, 5.355f, 21.372f, 6.329f, 22.292f)
                curveTo(6.942f, 22.872f, 7.169f, 23f, 7.701f, 23f)
                curveTo(8.233f, 23f, 8.459f, 22.872f, 9.073f, 22.292f)
                curveTo(10.046f, 21.372f, 10.701f, 21f, 11.932f, 21f)
                curveTo(13.163f, 21f, 13.818f, 21.372f, 14.792f, 22.292f)
                curveTo(15.405f, 22.872f, 15.632f, 23f, 16.164f, 23f)
                curveTo(16.696f, 23f, 16.922f, 22.872f, 17.536f, 22.292f)
                curveTo(18.509f, 21.372f, 19.164f, 21f, 20.395f, 21f)
                curveTo(21.626f, 21f, 22.281f, 21.372f, 23.255f, 22.292f)
                curveTo(23.868f, 22.872f, 24.095f, 23f, 24.627f, 23f)
                curveTo(25.159f, 23f, 25.385f, 22.872f, 25.999f, 22.292f)
                curveTo(26.972f, 21.372f, 27.627f, 21f, 28.858f, 21f)
                curveTo(30.578f, 21f, 32.24f, 21.786f, 33.833f, 23.292f)
                lineTo(32.346f, 24.708f)
                curveTo(31.118f, 23.548f, 29.959f, 23f, 28.858f, 23f)
                curveTo(28.326f, 23f, 28.1f, 23.128f, 27.486f, 23.708f)
                curveTo(26.513f, 24.628f, 25.858f, 25f, 24.627f, 25f)
                curveTo(23.396f, 25f, 22.741f, 24.628f, 21.767f, 23.708f)
                curveTo(21.154f, 23.128f, 20.927f, 23f, 20.395f, 23f)
                curveTo(19.863f, 23f, 19.637f, 23.128f, 19.023f, 23.708f)
                curveTo(18.05f, 24.628f, 17.395f, 25f, 16.164f, 25f)
                curveTo(14.933f, 25f, 14.278f, 24.628f, 13.304f, 23.708f)
                curveTo(12.691f, 23.128f, 12.464f, 23f, 11.932f, 23f)
                curveTo(11.4f, 23f, 11.174f, 23.128f, 10.56f, 23.708f)
                curveTo(9.587f, 24.628f, 8.932f, 25f, 7.701f, 25f)
                curveTo(6.47f, 25f, 5.815f, 24.628f, 4.841f, 23.708f)
                curveTo(4.228f, 23.128f, 4.001f, 23f, 3.469f, 23f)
                curveTo(2.368f, 23f, 1.209f, 23.548f, -0.019f, 24.708f)
                close()
            }
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(14f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-14f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(14f)
                verticalLineToRelative(10f)
                horizontalLineToRelative(-14f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(14f)
                verticalLineToRelative(10f)
                horizontalLineToRelative(-14f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-1.559f, 10.111f)
                lineTo(1.522f, 11.462f)
                lineTo(14.07f, 1.469f)
                lineTo(15.695f, -0.539f)
                lineTo(12.401f, -0.99f)
                lineTo(7.283f, 3.316f)
                lineTo(3.163f, 6.217f)
                lineTo(-1.559f, 10.111f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-1.137f, 11.058f)
                lineTo(0.432f, 11.842f)
                lineTo(15.111f, -0.725f)
                horizontalLineTo(12.908f)
                lineTo(-1.137f, 11.058f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(15.559f, 10.111f)
                lineTo(12.478f, 11.462f)
                lineTo(-0.07f, 1.469f)
                lineTo(-1.695f, -0.539f)
                lineTo(1.599f, -0.99f)
                lineTo(6.717f, 3.316f)
                lineTo(10.837f, 6.217f)
                lineTo(15.559f, 10.111f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(15.454f, 10.79f)
                lineTo(13.884f, 11.575f)
                lineTo(7.634f, 6.194f)
                lineTo(5.781f, 5.593f)
                lineTo(-1.851f, -0.532f)
                horizontalLineTo(0.352f)
                lineTo(7.98f, 5.447f)
                lineTo(10.006f, 6.168f)
                lineTo(15.454f, 10.79f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.766f, -0.444f)
                horizontalLineTo(6.21f)
                verticalLineTo(4.222f)
                horizontalLineTo(0f)
                verticalLineTo(5.778f)
                horizontalLineTo(6.21f)
                verticalLineTo(10.444f)
                horizontalLineTo(7.766f)
                verticalLineTo(5.778f)
                horizontalLineTo(14f)
                verticalLineTo(4.222f)
                horizontalLineTo(7.766f)
                verticalLineTo(-0.444f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.044f, -0.444f)
                horizontalLineTo(8.932f)
                verticalLineTo(3.056f)
                horizontalLineTo(14f)
                verticalLineTo(6.944f)
                horizontalLineTo(8.932f)
                lineTo(8.944f, 10.444f)
                horizontalLineTo(5.056f)
                lineTo(5.044f, 6.944f)
                horizontalLineTo(0f)
                verticalLineTo(3.056f)
                horizontalLineTo(5.044f)
                verticalLineTo(-0.444f)
                close()
                moveTo(6.21f, 4.222f)
                horizontalLineTo(0f)
                verticalLineTo(5.778f)
                horizontalLineTo(6.21f)
                verticalLineTo(10.444f)
                horizontalLineTo(7.766f)
                verticalLineTo(5.778f)
                horizontalLineTo(14f)
                verticalLineTo(4.222f)
                horizontalLineTo(7.766f)
                verticalLineTo(-0.444f)
                horizontalLineTo(6.21f)
                verticalLineTo(4.222f)
                close()
            }
        }
        path(fill = SolidColor(Color(0xFFD86D00))) {
            moveTo(20.9f, 9.379f)
            lineTo(20.9f, 9.379f)
            arcTo(0.5f, 0.5f, 0f, isMoreThanHalf = false, isPositiveArc = true, 21.4f, 9.879f)
            lineTo(21.4f, 21.5f)
            arcTo(0.5f, 0.5f, 0f, isMoreThanHalf = false, isPositiveArc = true, 20.9f, 22f)
            lineTo(20.9f, 22f)
            arcTo(0.5f, 0.5f, 0f, isMoreThanHalf = false, isPositiveArc = true, 20.4f, 21.5f)
            lineTo(20.4f, 9.879f)
            arcTo(0.5f, 0.5f, 0f, isMoreThanHalf = false, isPositiveArc = true, 20.9f, 9.379f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(20.404f, 2.058f)
            curveTo(21.232f, 3.192f, 21.571f, 4.533f, 21.601f, 5.897f)
            curveTo(22.535f, 4.631f, 24.093f, 3.597f, 24.821f, 3.155f)
            curveTo(24.153f, 3.623f, 23.806f, 4.316f, 23.415f, 5.096f)
            curveTo(23.223f, 5.478f, 23.021f, 5.882f, 22.765f, 6.29f)
            curveTo(24.357f, 5.718f, 25.938f, 5.571f, 25.938f, 5.571f)
            curveTo(24.877f, 5.872f, 23.899f, 6.487f, 22.948f, 7.084f)
            lineTo(22.948f, 7.084f)
            lineTo(22.948f, 7.084f)
            lineTo(22.948f, 7.084f)
            lineTo(22.948f, 7.084f)
            curveTo(22.601f, 7.302f, 22.258f, 7.517f, 21.916f, 7.714f)
            curveTo(24.988f, 8.871f, 25.46f, 10.545f, 25.46f, 10.545f)
            curveTo(25.084f, 10.212f, 24.271f, 9.856f, 22.737f, 9.185f)
            lineTo(22.737f, 9.184f)
            curveTo(22.443f, 9.056f, 22.123f, 8.916f, 21.774f, 8.762f)
            curveTo(22.003f, 9.605f, 22.281f, 10.265f, 22.546f, 10.896f)
            lineTo(22.625f, 11.083f)
            curveTo(22.625f, 11.083f, 20.5f, 10.509f, 20.096f, 8.861f)
            curveTo(18.903f, 9.819f, 17.615f, 10.364f, 17.01f, 10.58f)
            curveTo(17.01f, 10.58f, 18.45f, 9.018f, 19.507f, 7.981f)
            curveTo(18.119f, 7.824f, 15.512f, 7.696f, 15.512f, 7.696f)
            lineTo(15.698f, 7.652f)
            curveTo(16.746f, 7.402f, 18.367f, 7.016f, 19.853f, 7.036f)
            curveTo(18.26f, 6.143f, 17.28f, 4.935f, 16.979f, 4.529f)
            curveTo(17.232f, 4.753f, 17.939f, 5.034f, 18.903f, 5.417f)
            curveTo(19.309f, 5.578f, 19.762f, 5.758f, 20.246f, 5.96f)
            curveTo(20.338f, 4.276f, 20.404f, 2.058f, 20.404f, 2.058f)
            close()
            moveTo(16.879f, 4.389f)
            curveTo(16.889f, 4.433f, 16.923f, 4.48f, 16.979f, 4.529f)
            curveTo(16.913f, 4.44f, 16.879f, 4.389f, 16.879f, 4.389f)
            close()
            moveTo(25.219f, 2.924f)
            curveTo(25.075f, 2.993f, 24.943f, 3.07f, 24.821f, 3.155f)
            curveTo(25.068f, 3.006f, 25.219f, 2.924f, 25.219f, 2.924f)
            close()
            moveTo(20.69f, 7.016f)
            curveTo(20.751f, 6.989f, 20.82f, 6.974f, 20.892f, 6.974f)
            curveTo(20.93f, 6.974f, 20.967f, 6.978f, 21.003f, 6.986f)
            curveTo(21.013f, 6.956f, 21.024f, 6.927f, 21.035f, 6.897f)
            lineTo(20.704f, 6.92f)
            lineTo(20.69f, 7.016f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(14.512f, 0.058f)
                horizontalLineToRelative(12f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-12f)
                close()
                moveTo(20.404f, 2.058f)
                curveTo(21.232f, 3.192f, 21.571f, 4.533f, 21.601f, 5.897f)
                curveTo(22.535f, 4.631f, 24.093f, 3.597f, 24.821f, 3.155f)
                curveTo(24.153f, 3.623f, 23.806f, 4.316f, 23.415f, 5.096f)
                curveTo(23.223f, 5.478f, 23.021f, 5.882f, 22.765f, 6.29f)
                curveTo(24.357f, 5.718f, 25.938f, 5.571f, 25.938f, 5.571f)
                curveTo(24.877f, 5.872f, 23.899f, 6.487f, 22.948f, 7.084f)
                lineTo(22.948f, 7.084f)
                lineTo(22.948f, 7.084f)
                lineTo(22.948f, 7.084f)
                lineTo(22.948f, 7.084f)
                curveTo(22.601f, 7.302f, 22.258f, 7.517f, 21.916f, 7.714f)
                curveTo(24.988f, 8.871f, 25.46f, 10.545f, 25.46f, 10.545f)
                curveTo(25.084f, 10.212f, 24.271f, 9.856f, 22.737f, 9.185f)
                lineTo(22.737f, 9.184f)
                curveTo(22.443f, 9.056f, 22.123f, 8.916f, 21.774f, 8.762f)
                curveTo(22.003f, 9.605f, 22.281f, 10.265f, 22.546f, 10.896f)
                lineTo(22.625f, 11.083f)
                curveTo(22.625f, 11.083f, 20.5f, 10.509f, 20.096f, 8.861f)
                curveTo(18.903f, 9.819f, 17.615f, 10.364f, 17.01f, 10.58f)
                curveTo(17.01f, 10.58f, 18.45f, 9.018f, 19.507f, 7.981f)
                curveTo(18.119f, 7.824f, 15.512f, 7.696f, 15.512f, 7.696f)
                lineTo(15.698f, 7.652f)
                curveTo(16.746f, 7.402f, 18.367f, 7.016f, 19.853f, 7.036f)
                curveTo(18.26f, 6.143f, 17.28f, 4.935f, 16.979f, 4.529f)
                curveTo(17.232f, 4.753f, 17.939f, 5.034f, 18.903f, 5.417f)
                curveTo(19.309f, 5.578f, 19.762f, 5.758f, 20.246f, 5.96f)
                curveTo(20.338f, 4.276f, 20.404f, 2.058f, 20.404f, 2.058f)
                close()
                moveTo(16.879f, 4.389f)
                curveTo(16.889f, 4.433f, 16.923f, 4.48f, 16.979f, 4.529f)
                curveTo(16.913f, 4.44f, 16.879f, 4.389f, 16.879f, 4.389f)
                close()
                moveTo(25.219f, 2.924f)
                curveTo(25.075f, 2.993f, 24.943f, 3.07f, 24.821f, 3.155f)
                curveTo(25.068f, 3.006f, 25.219f, 2.924f, 25.219f, 2.924f)
                close()
                moveTo(20.69f, 7.016f)
                curveTo(20.751f, 6.989f, 20.82f, 6.974f, 20.892f, 6.974f)
                curveTo(20.93f, 6.974f, 20.967f, 6.978f, 21.003f, 6.986f)
                curveTo(21.013f, 6.956f, 21.024f, 6.927f, 21.035f, 6.897f)
                lineTo(20.704f, 6.92f)
                lineTo(20.69f, 7.016f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(21.601f, 5.897f)
                lineTo(21.251f, 5.905f)
                lineTo(21.274f, 6.929f)
                lineTo(21.883f, 6.105f)
                lineTo(21.601f, 5.897f)
                close()
                moveTo(20.404f, 2.058f)
                lineTo(20.687f, 1.851f)
                lineTo(20.085f, 1.026f)
                lineTo(20.054f, 2.047f)
                lineTo(20.404f, 2.058f)
                close()
                moveTo(23.415f, 5.096f)
                lineTo(23.102f, 4.939f)
                verticalLineTo(4.939f)
                lineTo(23.415f, 5.096f)
                close()
                moveTo(22.765f, 6.29f)
                lineTo(22.469f, 6.104f)
                lineTo(21.931f, 6.961f)
                lineTo(22.884f, 6.619f)
                lineTo(22.765f, 6.29f)
                close()
                moveTo(25.938f, 5.571f)
                lineTo(26.033f, 5.908f)
                lineTo(25.906f, 5.223f)
                lineTo(25.938f, 5.571f)
                close()
                moveTo(22.948f, 7.084f)
                lineTo(22.762f, 6.787f)
                lineTo(22.755f, 6.792f)
                lineTo(22.748f, 6.797f)
                lineTo(22.948f, 7.084f)
                close()
                moveTo(22.948f, 7.084f)
                lineTo(23.136f, 7.379f)
                lineTo(23.142f, 7.375f)
                lineTo(23.149f, 7.37f)
                lineTo(22.948f, 7.084f)
                close()
                moveTo(22.948f, 7.084f)
                lineTo(23.136f, 7.379f)
                lineTo(23.136f, 7.379f)
                lineTo(22.948f, 7.084f)
                close()
                moveTo(22.948f, 7.084f)
                lineTo(23.134f, 7.38f)
                lineTo(23.135f, 7.379f)
                lineTo(22.948f, 7.084f)
                close()
                moveTo(22.948f, 7.084f)
                lineTo(22.762f, 6.787f)
                lineTo(22.762f, 6.788f)
                lineTo(22.948f, 7.084f)
                close()
                moveTo(21.916f, 7.714f)
                lineTo(21.741f, 7.411f)
                lineTo(21.1f, 7.781f)
                lineTo(21.793f, 8.042f)
                lineTo(21.916f, 7.714f)
                close()
                moveTo(25.46f, 10.545f)
                lineTo(25.229f, 10.807f)
                lineTo(26.121f, 11.594f)
                lineTo(25.797f, 10.449f)
                lineTo(25.46f, 10.545f)
                close()
                moveTo(22.737f, 9.185f)
                lineTo(22.878f, 8.864f)
                lineTo(22.877f, 8.864f)
                lineTo(22.737f, 9.185f)
                close()
                moveTo(22.737f, 9.184f)
                lineTo(22.597f, 9.505f)
                lineTo(22.597f, 9.505f)
                lineTo(22.737f, 9.184f)
                close()
                moveTo(21.774f, 8.762f)
                lineTo(21.915f, 8.441f)
                lineTo(21.244f, 8.145f)
                lineTo(21.436f, 8.853f)
                lineTo(21.774f, 8.762f)
                close()
                moveTo(22.546f, 10.896f)
                lineTo(22.869f, 10.76f)
                lineTo(22.869f, 10.76f)
                lineTo(22.546f, 10.896f)
                close()
                moveTo(22.625f, 11.083f)
                lineTo(22.534f, 11.421f)
                lineTo(23.225f, 11.608f)
                lineTo(22.948f, 10.948f)
                lineTo(22.625f, 11.083f)
                close()
                moveTo(20.096f, 8.861f)
                lineTo(20.436f, 8.778f)
                lineTo(20.305f, 8.244f)
                lineTo(19.876f, 8.588f)
                lineTo(20.096f, 8.861f)
                close()
                moveTo(17.01f, 10.58f)
                lineTo(16.753f, 10.343f)
                lineTo(17.128f, 10.91f)
                lineTo(17.01f, 10.58f)
                close()
                moveTo(19.507f, 7.981f)
                lineTo(19.752f, 8.231f)
                lineTo(20.277f, 7.715f)
                lineTo(19.546f, 7.633f)
                lineTo(19.507f, 7.981f)
                close()
                moveTo(15.512f, 7.696f)
                lineTo(15.432f, 7.356f)
                lineTo(15.495f, 8.046f)
                lineTo(15.512f, 7.696f)
                close()
                moveTo(15.698f, 7.652f)
                lineTo(15.779f, 7.993f)
                lineTo(15.779f, 7.993f)
                lineTo(15.698f, 7.652f)
                close()
                moveTo(19.853f, 7.036f)
                lineTo(19.848f, 7.386f)
                lineTo(20.024f, 6.731f)
                lineTo(19.853f, 7.036f)
                close()
                moveTo(18.903f, 5.417f)
                lineTo(19.032f, 5.091f)
                horizontalLineTo(19.032f)
                lineTo(18.903f, 5.417f)
                close()
                moveTo(20.246f, 5.96f)
                lineTo(20.111f, 6.283f)
                lineTo(20.568f, 6.473f)
                lineTo(20.595f, 5.979f)
                lineTo(20.246f, 5.96f)
                close()
                moveTo(16.879f, 4.389f)
                lineTo(17.171f, 4.196f)
                lineTo(16.538f, 4.467f)
                lineTo(16.879f, 4.389f)
                close()
                moveTo(25.219f, 2.924f)
                lineTo(25.386f, 3.232f)
                lineTo(25.069f, 2.608f)
                lineTo(25.219f, 2.924f)
                close()
                moveTo(20.69f, 7.016f)
                lineTo(20.343f, 6.965f)
                lineTo(20.249f, 7.595f)
                lineTo(20.832f, 7.336f)
                lineTo(20.69f, 7.016f)
                close()
                moveTo(21.003f, 6.986f)
                lineTo(20.926f, 7.327f)
                lineTo(21.229f, 7.396f)
                lineTo(21.333f, 7.102f)
                lineTo(21.003f, 6.986f)
                close()
                moveTo(21.035f, 6.897f)
                lineTo(21.362f, 7.023f)
                lineTo(21.559f, 6.51f)
                lineTo(21.011f, 6.548f)
                lineTo(21.035f, 6.897f)
                close()
                moveTo(20.704f, 6.92f)
                lineTo(20.68f, 6.571f)
                lineTo(20.399f, 6.59f)
                lineTo(20.358f, 6.868f)
                lineTo(20.704f, 6.92f)
                close()
                moveTo(21.951f, 5.889f)
                curveTo(21.92f, 4.473f, 21.567f, 3.058f, 20.687f, 1.851f)
                lineTo(20.122f, 2.264f)
                curveTo(20.896f, 3.326f, 21.222f, 4.592f, 21.251f, 5.905f)
                lineTo(21.951f, 5.889f)
                close()
                moveTo(24.64f, 2.856f)
                curveTo(23.907f, 3.301f, 22.297f, 4.364f, 21.32f, 5.689f)
                lineTo(21.883f, 6.105f)
                curveTo(22.773f, 4.898f, 24.279f, 3.894f, 25.003f, 3.455f)
                lineTo(24.64f, 2.856f)
                close()
                moveTo(23.728f, 5.252f)
                curveTo(24.126f, 4.458f, 24.438f, 3.85f, 25.022f, 3.442f)
                lineTo(24.621f, 2.868f)
                curveTo(23.868f, 3.395f, 23.485f, 4.174f, 23.102f, 4.939f)
                lineTo(23.728f, 5.252f)
                close()
                moveTo(23.062f, 6.476f)
                curveTo(23.328f, 6.051f, 23.537f, 5.633f, 23.728f, 5.252f)
                lineTo(23.102f, 4.939f)
                curveTo(22.91f, 5.323f, 22.714f, 5.712f, 22.469f, 6.104f)
                lineTo(23.062f, 6.476f)
                close()
                moveTo(25.938f, 5.571f)
                curveTo(25.906f, 5.223f, 25.906f, 5.223f, 25.905f, 5.223f)
                curveTo(25.905f, 5.223f, 25.905f, 5.223f, 25.905f, 5.223f)
                curveTo(25.905f, 5.223f, 25.905f, 5.223f, 25.905f, 5.223f)
                curveTo(25.905f, 5.223f, 25.904f, 5.223f, 25.904f, 5.223f)
                curveTo(25.903f, 5.223f, 25.901f, 5.223f, 25.899f, 5.223f)
                curveTo(25.896f, 5.224f, 25.891f, 5.224f, 25.884f, 5.225f)
                curveTo(25.871f, 5.226f, 25.853f, 5.228f, 25.828f, 5.231f)
                curveTo(25.78f, 5.236f, 25.709f, 5.244f, 25.621f, 5.256f)
                curveTo(25.442f, 5.279f, 25.189f, 5.317f, 24.886f, 5.372f)
                curveTo(24.28f, 5.482f, 23.467f, 5.666f, 22.647f, 5.96f)
                lineTo(22.884f, 6.619f)
                curveTo(23.656f, 6.342f, 24.429f, 6.167f, 25.011f, 6.06f)
                curveTo(25.302f, 6.008f, 25.543f, 5.972f, 25.712f, 5.95f)
                curveTo(25.796f, 5.939f, 25.861f, 5.931f, 25.905f, 5.927f)
                curveTo(25.927f, 5.924f, 25.944f, 5.922f, 25.955f, 5.921f)
                curveTo(25.961f, 5.921f, 25.965f, 5.92f, 25.967f, 5.92f)
                curveTo(25.968f, 5.92f, 25.969f, 5.92f, 25.97f, 5.92f)
                curveTo(25.97f, 5.92f, 25.97f, 5.92f, 25.97f, 5.92f)
                curveTo(25.97f, 5.92f, 25.97f, 5.92f, 25.97f, 5.92f)
                curveTo(25.97f, 5.92f, 25.97f, 5.92f, 25.97f, 5.92f)
                curveTo(25.97f, 5.92f, 25.97f, 5.92f, 25.938f, 5.571f)
                close()
                moveTo(23.134f, 7.38f)
                curveTo(24.094f, 6.778f, 25.03f, 6.193f, 26.033f, 5.908f)
                lineTo(25.842f, 5.235f)
                curveTo(24.725f, 5.552f, 23.704f, 6.196f, 22.762f, 6.787f)
                lineTo(23.134f, 7.38f)
                close()
                moveTo(23.149f, 7.37f)
                lineTo(23.149f, 7.37f)
                lineTo(22.748f, 6.797f)
                lineTo(22.748f, 6.797f)
                lineTo(23.149f, 7.37f)
                close()
                moveTo(23.136f, 7.379f)
                lineTo(23.136f, 7.379f)
                lineTo(22.761f, 6.788f)
                lineTo(22.761f, 6.788f)
                lineTo(23.136f, 7.379f)
                close()
                moveTo(23.135f, 7.379f)
                lineTo(23.136f, 7.379f)
                lineTo(22.761f, 6.788f)
                lineTo(22.761f, 6.788f)
                lineTo(23.135f, 7.379f)
                close()
                moveTo(23.134f, 7.381f)
                lineTo(23.134f, 7.38f)
                lineTo(22.762f, 6.787f)
                lineTo(22.762f, 6.787f)
                lineTo(23.134f, 7.381f)
                close()
                moveTo(22.091f, 8.018f)
                curveTo(22.44f, 7.817f, 22.788f, 7.597f, 23.134f, 7.38f)
                lineTo(22.762f, 6.788f)
                curveTo(22.414f, 7.006f, 22.077f, 7.218f, 21.741f, 7.411f)
                lineTo(22.091f, 8.018f)
                close()
                moveTo(25.46f, 10.545f)
                curveTo(25.797f, 10.449f, 25.797f, 10.449f, 25.797f, 10.449f)
                curveTo(25.797f, 10.449f, 25.797f, 10.448f, 25.797f, 10.448f)
                curveTo(25.797f, 10.448f, 25.797f, 10.448f, 25.796f, 10.447f)
                curveTo(25.796f, 10.446f, 25.796f, 10.445f, 25.796f, 10.444f)
                curveTo(25.795f, 10.442f, 25.794f, 10.439f, 25.793f, 10.436f)
                curveTo(25.792f, 10.431f, 25.789f, 10.423f, 25.786f, 10.414f)
                curveTo(25.78f, 10.396f, 25.771f, 10.372f, 25.76f, 10.342f)
                curveTo(25.736f, 10.283f, 25.7f, 10.201f, 25.648f, 10.102f)
                curveTo(25.543f, 9.903f, 25.372f, 9.634f, 25.101f, 9.33f)
                curveTo(24.558f, 8.722f, 23.623f, 7.983f, 22.039f, 7.387f)
                lineTo(21.793f, 8.042f)
                curveTo(23.28f, 8.602f, 24.118f, 9.279f, 24.579f, 9.796f)
                curveTo(24.81f, 10.056f, 24.949f, 10.277f, 25.029f, 10.428f)
                curveTo(25.069f, 10.504f, 25.094f, 10.562f, 25.108f, 10.599f)
                curveTo(25.116f, 10.617f, 25.12f, 10.63f, 25.122f, 10.637f)
                curveTo(25.124f, 10.64f, 25.124f, 10.642f, 25.124f, 10.643f)
                curveTo(25.125f, 10.643f, 25.125f, 10.643f, 25.124f, 10.642f)
                curveTo(25.124f, 10.642f, 25.124f, 10.642f, 25.124f, 10.641f)
                curveTo(25.124f, 10.641f, 25.124f, 10.641f, 25.124f, 10.641f)
                curveTo(25.124f, 10.64f, 25.124f, 10.64f, 25.124f, 10.64f)
                curveTo(25.124f, 10.64f, 25.124f, 10.64f, 25.46f, 10.545f)
                close()
                moveTo(22.597f, 9.505f)
                curveTo(23.367f, 9.842f, 23.946f, 10.096f, 24.38f, 10.307f)
                curveTo(24.82f, 10.52f, 25.079f, 10.675f, 25.229f, 10.807f)
                lineTo(25.692f, 10.282f)
                curveTo(25.465f, 10.082f, 25.129f, 9.892f, 24.686f, 9.677f)
                curveTo(24.236f, 9.459f, 23.642f, 9.199f, 22.878f, 8.864f)
                lineTo(22.597f, 9.505f)
                close()
                moveTo(22.597f, 9.505f)
                lineTo(22.597f, 9.505f)
                lineTo(22.877f, 8.864f)
                lineTo(22.877f, 8.864f)
                lineTo(22.597f, 9.505f)
                close()
                moveTo(21.633f, 9.082f)
                curveTo(21.982f, 9.236f, 22.303f, 9.376f, 22.597f, 9.505f)
                lineTo(22.877f, 8.864f)
                curveTo(22.583f, 8.735f, 22.264f, 8.595f, 21.915f, 8.441f)
                lineTo(21.633f, 9.082f)
                close()
                moveTo(22.869f, 10.76f)
                curveTo(22.603f, 10.129f, 22.334f, 9.489f, 22.112f, 8.67f)
                lineTo(21.436f, 8.853f)
                curveTo(21.672f, 9.722f, 21.958f, 10.401f, 22.224f, 11.031f)
                lineTo(22.869f, 10.76f)
                close()
                moveTo(22.948f, 10.948f)
                lineTo(22.869f, 10.76f)
                lineTo(22.223f, 11.031f)
                lineTo(22.302f, 11.219f)
                lineTo(22.948f, 10.948f)
                close()
                moveTo(19.756f, 8.945f)
                curveTo(19.99f, 9.901f, 20.716f, 10.521f, 21.332f, 10.89f)
                curveTo(21.644f, 11.078f, 21.941f, 11.209f, 22.16f, 11.294f)
                curveTo(22.27f, 11.337f, 22.361f, 11.368f, 22.426f, 11.389f)
                curveTo(22.458f, 11.399f, 22.484f, 11.407f, 22.502f, 11.412f)
                curveTo(22.511f, 11.415f, 22.519f, 11.417f, 22.524f, 11.418f)
                curveTo(22.527f, 11.419f, 22.529f, 11.42f, 22.531f, 11.42f)
                curveTo(22.531f, 11.42f, 22.532f, 11.421f, 22.533f, 11.421f)
                curveTo(22.533f, 11.421f, 22.533f, 11.421f, 22.533f, 11.421f)
                curveTo(22.533f, 11.421f, 22.534f, 11.421f, 22.534f, 11.421f)
                curveTo(22.534f, 11.421f, 22.534f, 11.421f, 22.625f, 11.083f)
                curveTo(22.716f, 10.745f, 22.716f, 10.745f, 22.716f, 10.745f)
                curveTo(22.716f, 10.745f, 22.717f, 10.745f, 22.717f, 10.745f)
                curveTo(22.717f, 10.745f, 22.717f, 10.745f, 22.717f, 10.745f)
                curveTo(22.717f, 10.745f, 22.717f, 10.745f, 22.717f, 10.745f)
                curveTo(22.716f, 10.745f, 22.715f, 10.745f, 22.714f, 10.745f)
                curveTo(22.711f, 10.744f, 22.706f, 10.742f, 22.7f, 10.741f)
                curveTo(22.687f, 10.737f, 22.667f, 10.731f, 22.64f, 10.722f)
                curveTo(22.587f, 10.705f, 22.509f, 10.678f, 22.413f, 10.641f)
                curveTo(22.221f, 10.567f, 21.962f, 10.452f, 21.692f, 10.29f)
                curveTo(21.144f, 9.961f, 20.605f, 9.47f, 20.436f, 8.778f)
                lineTo(19.756f, 8.945f)
                close()
                moveTo(17.128f, 10.91f)
                curveTo(17.754f, 10.686f, 19.081f, 10.125f, 20.315f, 9.134f)
                lineTo(19.876f, 8.588f)
                curveTo(18.725f, 9.513f, 17.476f, 10.042f, 16.893f, 10.25f)
                lineTo(17.128f, 10.91f)
                close()
                moveTo(19.262f, 7.731f)
                curveTo(18.728f, 8.254f, 18.101f, 8.908f, 17.608f, 9.429f)
                curveTo(17.361f, 9.69f, 17.147f, 9.918f, 16.996f, 10.081f)
                curveTo(16.92f, 10.163f, 16.859f, 10.228f, 16.817f, 10.273f)
                curveTo(16.797f, 10.295f, 16.781f, 10.313f, 16.77f, 10.325f)
                curveTo(16.764f, 10.331f, 16.76f, 10.335f, 16.757f, 10.338f)
                curveTo(16.756f, 10.34f, 16.755f, 10.341f, 16.754f, 10.342f)
                curveTo(16.754f, 10.342f, 16.753f, 10.342f, 16.753f, 10.342f)
                curveTo(16.753f, 10.343f, 16.753f, 10.343f, 16.753f, 10.343f)
                curveTo(16.753f, 10.343f, 16.753f, 10.343f, 16.753f, 10.343f)
                curveTo(16.753f, 10.343f, 16.753f, 10.343f, 17.01f, 10.58f)
                curveTo(17.268f, 10.817f, 17.268f, 10.817f, 17.268f, 10.817f)
                curveTo(17.268f, 10.817f, 17.268f, 10.817f, 17.268f, 10.817f)
                curveTo(17.268f, 10.817f, 17.268f, 10.817f, 17.268f, 10.817f)
                curveTo(17.268f, 10.817f, 17.268f, 10.816f, 17.269f, 10.816f)
                curveTo(17.27f, 10.815f, 17.271f, 10.814f, 17.272f, 10.813f)
                curveTo(17.275f, 10.81f, 17.279f, 10.805f, 17.284f, 10.8f)
                curveTo(17.295f, 10.788f, 17.31f, 10.771f, 17.331f, 10.748f)
                curveTo(17.372f, 10.704f, 17.433f, 10.639f, 17.508f, 10.558f)
                curveTo(17.659f, 10.396f, 17.871f, 10.169f, 18.117f, 9.91f)
                curveTo(18.608f, 9.39f, 19.228f, 8.744f, 19.752f, 8.231f)
                lineTo(19.262f, 7.731f)
                close()
                moveTo(15.512f, 7.696f)
                curveTo(15.495f, 8.046f, 15.495f, 8.046f, 15.495f, 8.046f)
                curveTo(15.495f, 8.046f, 15.495f, 8.046f, 15.495f, 8.046f)
                curveTo(15.495f, 8.046f, 15.496f, 8.046f, 15.496f, 8.046f)
                curveTo(15.496f, 8.046f, 15.497f, 8.046f, 15.497f, 8.046f)
                curveTo(15.498f, 8.046f, 15.5f, 8.046f, 15.503f, 8.046f)
                curveTo(15.507f, 8.046f, 15.515f, 8.047f, 15.524f, 8.047f)
                curveTo(15.544f, 8.048f, 15.572f, 8.05f, 15.609f, 8.051f)
                curveTo(15.683f, 8.055f, 15.79f, 8.061f, 15.922f, 8.068f)
                curveTo(16.188f, 8.083f, 16.556f, 8.103f, 16.967f, 8.129f)
                curveTo(17.792f, 8.181f, 18.783f, 8.251f, 19.468f, 8.328f)
                lineTo(19.546f, 7.633f)
                curveTo(18.842f, 7.554f, 17.836f, 7.482f, 17.011f, 7.43f)
                curveTo(16.597f, 7.405f, 16.227f, 7.384f, 15.96f, 7.369f)
                curveTo(15.827f, 7.362f, 15.719f, 7.356f, 15.645f, 7.352f)
                curveTo(15.608f, 7.351f, 15.579f, 7.349f, 15.56f, 7.348f)
                curveTo(15.55f, 7.348f, 15.542f, 7.347f, 15.537f, 7.347f)
                curveTo(15.535f, 7.347f, 15.533f, 7.347f, 15.532f, 7.347f)
                curveTo(15.531f, 7.347f, 15.531f, 7.347f, 15.53f, 7.347f)
                curveTo(15.53f, 7.347f, 15.53f, 7.347f, 15.53f, 7.347f)
                curveTo(15.53f, 7.347f, 15.53f, 7.347f, 15.53f, 7.347f)
                curveTo(15.53f, 7.347f, 15.53f, 7.347f, 15.512f, 7.696f)
                close()
                moveTo(15.617f, 7.312f)
                lineTo(15.432f, 7.356f)
                lineTo(15.593f, 8.037f)
                lineTo(15.779f, 7.993f)
                lineTo(15.617f, 7.312f)
                close()
                moveTo(19.858f, 6.686f)
                curveTo(18.321f, 6.665f, 16.658f, 7.064f, 15.617f, 7.312f)
                lineTo(15.779f, 7.993f)
                curveTo(16.834f, 7.741f, 18.413f, 7.367f, 19.848f, 7.386f)
                lineTo(19.858f, 6.686f)
                close()
                moveTo(16.698f, 4.737f)
                curveTo(17.014f, 5.164f, 18.028f, 6.415f, 19.682f, 7.342f)
                lineTo(20.024f, 6.731f)
                curveTo(18.491f, 5.872f, 17.546f, 4.706f, 17.26f, 4.32f)
                lineTo(16.698f, 4.737f)
                close()
                moveTo(19.032f, 5.091f)
                curveTo(18.548f, 4.899f, 18.137f, 4.736f, 17.816f, 4.593f)
                curveTo(17.482f, 4.445f, 17.291f, 4.338f, 17.21f, 4.266f)
                lineTo(16.747f, 4.791f)
                curveTo(16.92f, 4.944f, 17.209f, 5.089f, 17.532f, 5.233f)
                curveTo(17.869f, 5.382f, 18.294f, 5.551f, 18.773f, 5.742f)
                lineTo(19.032f, 5.091f)
                close()
                moveTo(20.38f, 5.637f)
                curveTo(19.894f, 5.434f, 19.438f, 5.253f, 19.032f, 5.091f)
                lineTo(18.773f, 5.742f)
                curveTo(19.18f, 5.904f, 19.631f, 6.082f, 20.111f, 6.283f)
                lineTo(20.38f, 5.637f)
                close()
                moveTo(20.404f, 2.058f)
                curveTo(20.054f, 2.047f, 20.054f, 2.047f, 20.054f, 2.047f)
                curveTo(20.054f, 2.047f, 20.054f, 2.047f, 20.054f, 2.047f)
                curveTo(20.054f, 2.047f, 20.054f, 2.047f, 20.054f, 2.047f)
                curveTo(20.054f, 2.048f, 20.054f, 2.048f, 20.054f, 2.049f)
                curveTo(20.054f, 2.05f, 20.054f, 2.051f, 20.054f, 2.053f)
                curveTo(20.054f, 2.058f, 20.054f, 2.064f, 20.054f, 2.072f)
                curveTo(20.053f, 2.089f, 20.052f, 2.113f, 20.051f, 2.145f)
                curveTo(20.049f, 2.209f, 20.046f, 2.302f, 20.043f, 2.419f)
                curveTo(20.035f, 2.653f, 20.024f, 2.982f, 20.01f, 3.364f)
                curveTo(19.982f, 4.129f, 19.942f, 5.102f, 19.896f, 5.941f)
                lineTo(20.595f, 5.979f)
                curveTo(20.642f, 5.134f, 20.681f, 4.156f, 20.709f, 3.39f)
                curveTo(20.723f, 3.007f, 20.735f, 2.676f, 20.742f, 2.442f)
                curveTo(20.746f, 2.325f, 20.749f, 2.231f, 20.751f, 2.167f)
                curveTo(20.752f, 2.135f, 20.753f, 2.11f, 20.753f, 2.094f)
                curveTo(20.754f, 2.085f, 20.754f, 2.079f, 20.754f, 2.074f)
                curveTo(20.754f, 2.072f, 20.754f, 2.071f, 20.754f, 2.07f)
                curveTo(20.754f, 2.069f, 20.754f, 2.069f, 20.754f, 2.068f)
                curveTo(20.754f, 2.068f, 20.754f, 2.068f, 20.754f, 2.068f)
                curveTo(20.754f, 2.068f, 20.754f, 2.068f, 20.754f, 2.068f)
                curveTo(20.754f, 2.068f, 20.754f, 2.068f, 20.404f, 2.058f)
                close()
                moveTo(16.538f, 4.467f)
                curveTo(16.572f, 4.618f, 16.672f, 4.725f, 16.747f, 4.791f)
                lineTo(17.21f, 4.266f)
                curveTo(17.196f, 4.254f, 17.194f, 4.249f, 17.196f, 4.253f)
                curveTo(17.199f, 4.257f, 17.212f, 4.277f, 17.22f, 4.311f)
                lineTo(16.538f, 4.467f)
                close()
                moveTo(17.26f, 4.32f)
                curveTo(17.229f, 4.278f, 17.206f, 4.246f, 17.191f, 4.225f)
                curveTo(17.184f, 4.214f, 17.178f, 4.207f, 17.175f, 4.202f)
                curveTo(17.173f, 4.199f, 17.172f, 4.197f, 17.171f, 4.197f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 17.171f, 4.196f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 17.171f, 4.196f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 17.171f, 4.196f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 17.171f, 4.196f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 17.171f, 4.196f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 17.171f, 4.196f)
                curveTo(17.171f, 4.196f, 17.171f, 4.196f, 16.879f, 4.389f)
                curveTo(16.587f, 4.582f, 16.587f, 4.582f, 16.587f, 4.582f)
                curveTo(16.587f, 4.582f, 16.587f, 4.582f, 16.587f, 4.582f)
                curveTo(16.587f, 4.582f, 16.587f, 4.582f, 16.587f, 4.582f)
                curveTo(16.587f, 4.582f, 16.587f, 4.582f, 16.587f, 4.582f)
                curveTo(16.587f, 4.582f, 16.587f, 4.583f, 16.588f, 4.583f)
                curveTo(16.588f, 4.583f, 16.588f, 4.583f, 16.588f, 4.584f)
                curveTo(16.589f, 4.584f, 16.589f, 4.585f, 16.59f, 4.586f)
                curveTo(16.591f, 4.588f, 16.593f, 4.591f, 16.596f, 4.595f)
                curveTo(16.601f, 4.602f, 16.608f, 4.613f, 16.617f, 4.626f)
                curveTo(16.636f, 4.652f, 16.662f, 4.69f, 16.698f, 4.737f)
                lineTo(17.26f, 4.32f)
                close()
                moveTo(25.069f, 2.608f)
                curveTo(24.907f, 2.685f, 24.758f, 2.772f, 24.621f, 2.868f)
                lineTo(25.022f, 3.442f)
                curveTo(25.127f, 3.368f, 25.243f, 3.301f, 25.37f, 3.24f)
                lineTo(25.069f, 2.608f)
                close()
                moveTo(25.003f, 3.455f)
                curveTo(25.123f, 3.381f, 25.22f, 3.325f, 25.286f, 3.287f)
                curveTo(25.319f, 3.269f, 25.345f, 3.254f, 25.362f, 3.245f)
                curveTo(25.37f, 3.24f, 25.376f, 3.237f, 25.381f, 3.235f)
                curveTo(25.382f, 3.234f, 25.384f, 3.233f, 25.385f, 3.232f)
                curveTo(25.385f, 3.232f, 25.386f, 3.232f, 25.386f, 3.232f)
                curveTo(25.386f, 3.232f, 25.386f, 3.232f, 25.386f, 3.232f)
                curveTo(25.386f, 3.232f, 25.386f, 3.232f, 25.386f, 3.232f)
                curveTo(25.386f, 3.232f, 25.386f, 3.232f, 25.386f, 3.232f)
                curveTo(25.386f, 3.232f, 25.386f, 3.232f, 25.386f, 3.232f)
                curveTo(25.386f, 3.232f, 25.386f, 3.232f, 25.219f, 2.924f)
                curveTo(25.053f, 2.616f, 25.053f, 2.616f, 25.053f, 2.616f)
                curveTo(25.053f, 2.616f, 25.053f, 2.616f, 25.053f, 2.616f)
                curveTo(25.053f, 2.616f, 25.053f, 2.616f, 25.053f, 2.616f)
                curveTo(25.053f, 2.616f, 25.053f, 2.616f, 25.053f, 2.616f)
                curveTo(25.053f, 2.616f, 25.053f, 2.616f, 25.052f, 2.616f)
                curveTo(25.052f, 2.616f, 25.051f, 2.617f, 25.051f, 2.617f)
                curveTo(25.049f, 2.618f, 25.047f, 2.619f, 25.045f, 2.62f)
                curveTo(25.039f, 2.623f, 25.032f, 2.627f, 25.022f, 2.633f)
                curveTo(25.003f, 2.643f, 24.975f, 2.659f, 24.94f, 2.679f)
                curveTo(24.868f, 2.72f, 24.766f, 2.779f, 24.64f, 2.856f)
                lineTo(25.003f, 3.455f)
                close()
                moveTo(20.892f, 6.624f)
                curveTo(20.77f, 6.624f, 20.653f, 6.649f, 20.548f, 6.696f)
                lineTo(20.832f, 7.336f)
                curveTo(20.85f, 7.328f, 20.87f, 7.324f, 20.892f, 7.324f)
                verticalLineTo(6.624f)
                close()
                moveTo(21.079f, 6.644f)
                curveTo(21.019f, 6.631f, 20.956f, 6.624f, 20.892f, 6.624f)
                verticalLineTo(7.324f)
                curveTo(20.904f, 7.324f, 20.915f, 7.325f, 20.926f, 7.327f)
                lineTo(21.079f, 6.644f)
                close()
                moveTo(21.333f, 7.102f)
                curveTo(21.342f, 7.076f, 21.352f, 7.05f, 21.362f, 7.023f)
                lineTo(20.709f, 6.771f)
                curveTo(20.696f, 6.804f, 20.684f, 6.837f, 20.672f, 6.87f)
                lineTo(21.333f, 7.102f)
                close()
                moveTo(21.011f, 6.548f)
                lineTo(20.68f, 6.571f)
                lineTo(20.728f, 7.269f)
                lineTo(21.059f, 7.246f)
                lineTo(21.011f, 6.548f)
                close()
                moveTo(20.358f, 6.868f)
                lineTo(20.343f, 6.965f)
                lineTo(21.036f, 7.068f)
                lineTo(21.05f, 6.972f)
                lineTo(20.358f, 6.868f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFF50100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(24.285f, 15.819f)
            verticalLineTo(15.638f)
            curveTo(23.758f, 15.184f, 23.207f, 14.956f, 22.63f, 14.956f)
            curveTo(22.078f, 14.662f, 21.518f, 14.547f, 20.952f, 14.613f)
            curveTo(20.952f, 14.611f, 20.953f, 14.61f, 20.953f, 14.61f)
            curveTo(20.101f, 14.51f, 19.244f, 14.956f, 19.244f, 14.956f)
            curveTo(18.379f, 14.956f, 17.589f, 15.638f, 17.589f, 15.638f)
            verticalLineTo(15.819f)
            lineTo(18.622f, 17.067f)
            curveTo(18.622f, 17.067f, 18.912f, 18.269f, 20.948f, 17.986f)
            verticalLineTo(17.989f)
            curveTo(20.948f, 17.989f, 22.296f, 17.945f, 22.391f, 17.907f)
            curveTo(22.429f, 17.892f, 22.468f, 17.878f, 22.507f, 17.865f)
            curveTo(22.771f, 17.772f, 23.073f, 17.666f, 23.252f, 17.067f)
            lineTo(24.285f, 15.819f)
            close()
            moveTo(20.948f, 14.668f)
            curveTo(20.919f, 15.084f, 20.751f, 17.59f, 20.948f, 17.978f)
            verticalLineTo(14.668f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFECA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(19.266f, 14.417f)
            curveTo(19.376f, 14.012f, 19.569f, 13.874f, 20.037f, 13.874f)
            curveTo(20.327f, 13.874f, 20.547f, 13.956f, 20.7f, 14.116f)
            verticalLineTo(15.198f)
            horizontalLineTo(20.782f)
            verticalLineTo(15.327f)
            curveTo(20.717f, 15.375f, 20.683f, 15.478f, 20.705f, 15.589f)
            curveTo(20.712f, 15.627f, 20.725f, 15.661f, 20.742f, 15.691f)
            curveTo(20.708f, 15.679f, 20.669f, 15.672f, 20.628f, 15.672f)
            curveTo(20.487f, 15.672f, 20.372f, 15.755f, 20.372f, 15.857f)
            curveTo(20.372f, 15.959f, 20.487f, 16.042f, 20.628f, 16.042f)
            curveTo(20.769f, 16.042f, 20.884f, 15.959f, 20.884f, 15.857f)
            curveTo(20.884f, 15.908f, 20.913f, 15.955f, 20.96f, 15.988f)
            horizontalLineTo(20.834f)
            horizontalLineTo(20.831f)
            curveTo(20.831f, 16.267f, 20.713f, 16.444f, 20.536f, 16.444f)
            curveTo(20.412f, 16.444f, 20.325f, 16.376f, 20.262f, 16.226f)
            lineTo(20.087f, 15.81f)
            lineTo(20.069f, 16.276f)
            curveTo(20.062f, 16.44f, 20.003f, 16.505f, 19.855f, 16.505f)
            curveTo(19.712f, 16.505f, 19.609f, 16.399f, 19.539f, 16.159f)
            curveTo(19.56f, 16.163f, 19.581f, 16.165f, 19.604f, 16.165f)
            curveTo(19.745f, 16.165f, 19.86f, 16.082f, 19.86f, 15.98f)
            curveTo(19.86f, 15.878f, 19.745f, 15.795f, 19.604f, 15.795f)
            curveTo(19.576f, 15.795f, 19.549f, 15.799f, 19.523f, 15.805f)
            curveTo(19.539f, 15.757f, 19.543f, 15.7f, 19.532f, 15.641f)
            curveTo(19.505f, 15.503f, 19.402f, 15.406f, 19.302f, 15.425f)
            curveTo(19.201f, 15.445f, 19.142f, 15.573f, 19.169f, 15.712f)
            curveTo(19.176f, 15.75f, 19.189f, 15.785f, 19.206f, 15.815f)
            curveTo(19.172f, 15.802f, 19.133f, 15.795f, 19.092f, 15.795f)
            curveTo(18.951f, 15.795f, 18.836f, 15.878f, 18.836f, 15.98f)
            curveTo(18.836f, 16.082f, 18.951f, 16.165f, 19.092f, 16.165f)
            curveTo(19.207f, 16.165f, 19.304f, 16.111f, 19.336f, 16.035f)
            lineTo(19.328f, 16.144f)
            curveTo(19.306f, 16.451f, 19.236f, 16.595f, 19.133f, 16.615f)
            curveTo(18.993f, 16.642f, 18.886f, 16.629f, 18.812f, 16.581f)
            lineTo(18.661f, 16.483f)
            verticalLineTo(16.65f)
            curveTo(18.613f, 16.656f, 18.532f, 16.646f, 18.42f, 16.616f)
            lineTo(18.403f, 16.713f)
            lineTo(18.215f, 16.5f)
            curveTo(18.272f, 16.508f, 18.339f, 16.497f, 18.402f, 16.463f)
            curveTo(18.526f, 16.397f, 18.589f, 16.27f, 18.541f, 16.18f)
            curveTo(18.493f, 16.09f, 18.353f, 16.07f, 18.228f, 16.137f)
            curveTo(18.202f, 16.151f, 18.178f, 16.167f, 18.158f, 16.186f)
            curveTo(18.156f, 16.165f, 18.151f, 16.145f, 18.145f, 16.124f)
            curveTo(18.104f, 15.989f, 17.991f, 15.903f, 17.893f, 15.933f)
            curveTo(17.85f, 15.947f, 17.816f, 15.981f, 17.797f, 16.027f)
            lineTo(17.721f, 15.941f)
            lineTo(17.651f, 16.031f)
            lineTo(17.779f, 16.176f)
            curveTo(17.782f, 16.195f, 17.786f, 16.213f, 17.792f, 16.232f)
            curveTo(17.827f, 16.349f, 17.916f, 16.428f, 18.003f, 16.429f)
            lineTo(18.377f, 16.853f)
            lineTo(18.377f, 16.857f)
            lineTo(18.382f, 16.858f)
            lineTo(18.59f, 17.094f)
            curveTo(18.621f, 17.162f, 18.648f, 17.224f, 18.671f, 17.281f)
            curveTo(18.697f, 17.403f, 18.735f, 17.539f, 18.789f, 17.622f)
            curveTo(18.794f, 17.646f, 18.796f, 17.666f, 18.796f, 17.682f)
            curveTo(18.796f, 17.809f, 19.071f, 17.884f, 19.607f, 17.962f)
            curveTo(20.027f, 18.022f, 20.522f, 18.063f, 20.928f, 18.069f)
            verticalLineTo(18.07f)
            lineTo(20.979f, 18.07f)
            lineTo(21.03f, 18.07f)
            verticalLineTo(18.069f)
            curveTo(21.436f, 18.063f, 21.931f, 18.022f, 22.351f, 17.962f)
            curveTo(22.887f, 17.884f, 23.162f, 17.809f, 23.162f, 17.682f)
            curveTo(23.162f, 17.598f, 23.231f, 17.398f, 23.368f, 17.094f)
            lineTo(24.307f, 16.031f)
            lineTo(24.237f, 15.941f)
            lineTo(24.003f, 16.206f)
            lineTo(24.007f, 16.194f)
            curveTo(24.048f, 16.059f, 24.002f, 15.925f, 23.905f, 15.896f)
            curveTo(23.807f, 15.866f, 23.694f, 15.951f, 23.653f, 16.086f)
            curveTo(23.647f, 16.107f, 23.642f, 16.128f, 23.64f, 16.148f)
            curveTo(23.62f, 16.129f, 23.597f, 16.113f, 23.57f, 16.099f)
            curveTo(23.445f, 16.033f, 23.305f, 16.052f, 23.257f, 16.142f)
            curveTo(23.209f, 16.232f, 23.272f, 16.359f, 23.397f, 16.425f)
            curveTo(23.521f, 16.492f, 23.662f, 16.472f, 23.709f, 16.382f)
            curveTo(23.712f, 16.377f, 23.715f, 16.372f, 23.717f, 16.367f)
            curveTo(23.728f, 16.375f, 23.741f, 16.381f, 23.755f, 16.385f)
            curveTo(23.785f, 16.394f, 23.817f, 16.393f, 23.848f, 16.382f)
            lineTo(23.482f, 16.795f)
            lineTo(23.45f, 16.616f)
            curveTo(23.338f, 16.646f, 23.257f, 16.656f, 23.209f, 16.65f)
            verticalLineTo(16.483f)
            lineTo(23.058f, 16.581f)
            curveTo(22.984f, 16.629f, 22.877f, 16.642f, 22.737f, 16.615f)
            curveTo(22.634f, 16.595f, 22.565f, 16.451f, 22.542f, 16.144f)
            lineTo(22.54f, 16.12f)
            curveTo(22.575f, 16.141f, 22.618f, 16.156f, 22.664f, 16.163f)
            curveTo(22.804f, 16.182f, 22.929f, 16.116f, 22.943f, 16.015f)
            curveTo(22.958f, 15.914f, 22.856f, 15.816f, 22.716f, 15.796f)
            curveTo(22.683f, 15.792f, 22.652f, 15.792f, 22.623f, 15.796f)
            curveTo(22.648f, 15.75f, 22.662f, 15.691f, 22.658f, 15.627f)
            curveTo(22.651f, 15.486f, 22.562f, 15.376f, 22.46f, 15.381f)
            curveTo(22.358f, 15.386f, 22.282f, 15.505f, 22.289f, 15.646f)
            curveTo(22.291f, 15.679f, 22.297f, 15.711f, 22.307f, 15.74f)
            curveTo(22.278f, 15.726f, 22.244f, 15.716f, 22.209f, 15.711f)
            curveTo(22.069f, 15.691f, 21.944f, 15.757f, 21.929f, 15.858f)
            curveTo(21.915f, 15.959f, 22.017f, 16.057f, 22.157f, 16.077f)
            curveTo(22.236f, 16.088f, 22.311f, 16.072f, 22.363f, 16.037f)
            lineTo(22.342f, 16.118f)
            curveTo(22.272f, 16.387f, 22.166f, 16.505f, 22.015f, 16.505f)
            curveTo(21.867f, 16.505f, 21.808f, 16.44f, 21.802f, 16.276f)
            lineTo(21.783f, 15.81f)
            lineTo(21.608f, 16.226f)
            curveTo(21.545f, 16.376f, 21.458f, 16.444f, 21.334f, 16.444f)
            curveTo(21.166f, 16.444f, 21.05f, 16.283f, 21.04f, 16.027f)
            curveTo(21.071f, 16.036f, 21.104f, 16.042f, 21.14f, 16.042f)
            curveTo(21.281f, 16.042f, 21.396f, 15.959f, 21.396f, 15.857f)
            curveTo(21.396f, 15.755f, 21.281f, 15.672f, 21.14f, 15.672f)
            curveTo(21.112f, 15.672f, 21.084f, 15.675f, 21.059f, 15.681f)
            curveTo(21.075f, 15.634f, 21.079f, 15.577f, 21.068f, 15.518f)
            curveTo(21.057f, 15.46f, 21.032f, 15.41f, 21f, 15.372f)
            horizontalLineTo(21.191f)
            verticalLineTo(15.218f)
            verticalLineTo(14.135f)
            curveTo(21.344f, 13.975f, 21.563f, 13.893f, 21.854f, 13.893f)
            curveTo(22.323f, 13.893f, 22.515f, 14.031f, 22.625f, 14.436f)
            curveTo(22.695f, 14.694f, 22.627f, 14.915f, 22.407f, 15.12f)
            lineTo(22.532f, 15.315f)
            curveTo(22.778f, 15.085f, 22.887f, 14.811f, 22.849f, 14.507f)
            curveTo(23.375f, 14.486f, 23.769f, 14.553f, 24.028f, 14.705f)
            curveTo(24.253f, 14.837f, 24.294f, 15.173f, 24.124f, 15.757f)
            lineTo(24.317f, 15.838f)
            curveTo(24.517f, 15.151f, 24.46f, 14.685f, 24.117f, 14.483f)
            curveTo(23.816f, 14.306f, 23.376f, 14.234f, 22.795f, 14.262f)
            lineTo(22.796f, 14.28f)
            curveTo(22.649f, 13.823f, 22.375f, 13.647f, 21.854f, 13.647f)
            curveTo(21.59f, 13.647f, 21.368f, 13.708f, 21.191f, 13.833f)
            verticalLineTo(13.77f)
            horizontalLineTo(20.782f)
            verticalLineTo(13.879f)
            curveTo(20.594f, 13.711f, 20.344f, 13.628f, 20.037f, 13.628f)
            curveTo(19.526f, 13.628f, 19.253f, 13.797f, 19.104f, 14.233f)
            lineTo(19.107f, 14.139f)
            curveTo(18.527f, 14.111f, 18.087f, 14.183f, 17.785f, 14.36f)
            curveTo(17.443f, 14.561f, 17.385f, 15.028f, 17.586f, 15.715f)
            lineTo(17.779f, 15.633f)
            curveTo(17.609f, 15.05f, 17.65f, 14.714f, 17.875f, 14.582f)
            curveTo(18.135f, 14.429f, 18.531f, 14.362f, 19.061f, 14.384f)
            curveTo(18.982f, 14.729f, 19.085f, 15.04f, 19.359f, 15.296f)
            lineTo(19.484f, 15.101f)
            curveTo(19.264f, 14.895f, 19.196f, 14.675f, 19.266f, 14.417f)
            close()
            moveTo(20.884f, 15.857f)
            curveTo(20.884f, 15.839f, 20.887f, 15.822f, 20.894f, 15.806f)
            curveTo(20.887f, 15.806f, 20.88f, 15.804f, 20.873f, 15.802f)
            curveTo(20.88f, 15.82f, 20.884f, 15.838f, 20.884f, 15.857f)
            close()
            moveTo(19.343f, 15.944f)
            curveTo(19.341f, 15.938f, 19.339f, 15.932f, 19.337f, 15.926f)
            lineTo(19.344f, 15.927f)
            lineTo(19.343f, 15.944f)
            close()
            moveTo(23.41f, 16.877f)
            curveTo(23.243f, 16.913f, 23.122f, 16.909f, 23.057f, 16.846f)
            curveTo(22.957f, 16.881f, 22.839f, 16.885f, 22.704f, 16.858f)
            curveTo(22.56f, 16.83f, 22.46f, 16.715f, 22.4f, 16.524f)
            curveTo(22.322f, 16.645f, 22.222f, 16.719f, 22.103f, 16.743f)
            curveTo(22.758f, 16.855f, 23.217f, 17.012f, 23.217f, 17.012f)
            curveTo(23.217f, 17.012f, 23.206f, 17.129f, 23.178f, 17.267f)
            curveTo(23.208f, 17.195f, 23.242f, 17.115f, 23.282f, 17.027f)
            lineTo(23.292f, 17.011f)
            lineTo(23.41f, 16.877f)
            close()
            moveTo(21.794f, 16.696f)
            curveTo(21.737f, 16.662f, 21.691f, 16.613f, 21.658f, 16.549f)
            curveTo(21.609f, 16.601f, 21.554f, 16.639f, 21.492f, 16.663f)
            curveTo(21.595f, 16.672f, 21.696f, 16.684f, 21.794f, 16.696f)
            close()
            moveTo(21.131f, 16.639f)
            curveTo(21.051f, 16.594f, 20.985f, 16.523f, 20.935f, 16.432f)
            curveTo(20.886f, 16.523f, 20.82f, 16.593f, 20.741f, 16.638f)
            curveTo(20.788f, 16.636f, 20.835f, 16.635f, 20.882f, 16.634f)
            verticalLineTo(16.634f)
            lineTo(20.923f, 16.634f)
            lineTo(20.964f, 16.634f)
            verticalLineTo(16.634f)
            curveTo(21.02f, 16.635f, 21.076f, 16.636f, 21.131f, 16.639f)
            close()
            moveTo(18.659f, 17.003f)
            lineTo(18.563f, 16.895f)
            curveTo(18.678f, 16.908f, 18.763f, 16.895f, 18.813f, 16.846f)
            curveTo(18.913f, 16.881f, 19.031f, 16.885f, 19.166f, 16.858f)
            curveTo(19.31f, 16.83f, 19.41f, 16.715f, 19.47f, 16.524f)
            curveTo(19.546f, 16.641f, 19.642f, 16.715f, 19.757f, 16.741f)
            curveTo(19.192f, 16.837f, 18.77f, 16.967f, 18.659f, 17.003f)
            close()
            moveTo(20.374f, 16.661f)
            curveTo(20.274f, 16.67f, 20.177f, 16.681f, 20.083f, 16.693f)
            curveTo(20.137f, 16.659f, 20.18f, 16.611f, 20.212f, 16.549f)
            curveTo(20.26f, 16.6f, 20.314f, 16.637f, 20.374f, 16.661f)
            close()
            moveTo(22.893f, 17.684f)
            curveTo(22.964f, 17.724f, 23.022f, 17.684f, 23.067f, 17.607f)
            curveTo(23.063f, 17.628f, 23.061f, 17.647f, 23.06f, 17.665f)
            curveTo(23.054f, 17.669f, 23.045f, 17.675f, 23.033f, 17.681f)
            curveTo(22.999f, 17.698f, 22.948f, 17.716f, 22.881f, 17.735f)
            curveTo(22.749f, 17.771f, 22.561f, 17.807f, 22.339f, 17.839f)
            curveTo(21.905f, 17.902f, 21.389f, 17.943f, 20.979f, 17.946f)
            curveTo(20.569f, 17.943f, 20.053f, 17.902f, 19.619f, 17.839f)
            curveTo(19.397f, 17.807f, 19.209f, 17.771f, 19.078f, 17.735f)
            curveTo(19.021f, 17.719f, 18.976f, 17.704f, 18.943f, 17.69f)
            curveTo(18.947f, 17.688f, 18.95f, 17.686f, 18.954f, 17.684f)
            curveTo(19.178f, 17.558f, 20.657f, 17.44f, 20.923f, 17.419f)
            curveTo(21.19f, 17.44f, 22.669f, 17.558f, 22.893f, 17.684f)
            close()
            moveTo(23.19f, 17.661f)
            curveTo(23.19f, 17.662f, 23.189f, 17.662f, 23.189f, 17.663f)
            lineTo(23.189f, 17.662f)
            lineTo(23.19f, 17.661f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(19.133f, 14.038f)
            lineTo(19.131f, 14.162f)
            curveTo(18.223f, 14.142f, 17.702f, 14.302f, 17.57f, 14.62f)
            curveTo(17.433f, 14.948f, 17.459f, 15.348f, 17.65f, 15.822f)
            lineTo(17.558f, 15.876f)
            curveTo(17.354f, 15.37f, 17.326f, 14.931f, 17.478f, 14.565f)
            curveTo(17.635f, 14.187f, 18.186f, 14.019f, 19.133f, 14.038f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(19.308f, 15.131f)
            lineTo(19.256f, 15.237f)
            curveTo(19.058f, 15.095f, 18.959f, 14.852f, 18.959f, 14.518f)
            curveTo(18.959f, 14.038f, 19.165f, 13.756f, 19.619f, 13.564f)
            curveTo(19.91f, 13.441f, 20.306f, 13.491f, 20.81f, 13.711f)
            lineTo(20.775f, 13.827f)
            curveTo(20.291f, 13.616f, 19.917f, 13.568f, 19.653f, 13.68f)
            curveTo(19.236f, 13.857f, 19.062f, 14.096f, 19.062f, 14.518f)
            curveTo(19.062f, 14.811f, 19.144f, 15.013f, 19.308f, 15.131f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(22.706f, 14.162f)
            lineTo(22.708f, 14.285f)
            curveTo(23.616f, 14.266f, 24.137f, 14.425f, 24.269f, 14.743f)
            curveTo(24.406f, 15.072f, 24.38f, 15.471f, 24.189f, 15.946f)
            lineTo(24.281f, 15.999f)
            curveTo(24.485f, 15.493f, 24.513f, 15.055f, 24.361f, 14.688f)
            curveTo(24.204f, 14.31f, 23.653f, 14.142f, 22.706f, 14.162f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(22.385f, 15.157f)
            lineTo(22.438f, 15.263f)
            curveTo(22.636f, 15.12f, 22.735f, 14.878f, 22.735f, 14.544f)
            curveTo(22.735f, 14.064f, 22.529f, 13.782f, 22.074f, 13.589f)
            curveTo(21.784f, 13.466f, 21.388f, 13.517f, 20.884f, 13.736f)
            lineTo(20.919f, 13.852f)
            curveTo(21.403f, 13.641f, 21.777f, 13.594f, 22.04f, 13.705f)
            curveTo(22.458f, 13.882f, 22.632f, 14.122f, 22.632f, 14.544f)
            curveTo(22.632f, 14.837f, 22.55f, 15.038f, 22.385f, 15.157f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun BritishIndianOceanTerritoryPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.BritishIndianOceanTerritory,
            contentDescription = "British Indian Ocean Territory Flag"
        )
    }
}
